<template>
  <div class="feeInvoiceDetailQuery">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input
            class="searchInput"
            v-model="searchInvoiceNo"
            placeholder="发票编号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchInvoiceType"
            placeholder="发票类型"
            class="searchInput"
          >
            <el-option label="全部" :value="''"></el-option>
            <el-option label="专票" :value="1"></el-option>
            <el-option label="普票" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="commit">查询</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          label="序号"
          width="100px"
        ></el-table-column>
        <el-table-column prop="invoiceNo" label="发票编号"></el-table-column>
        <!-- <el-table-column prop="detailId" label="缴费ID"></el-table-column> -->

        <el-table-column prop="invoiceType" label="发票类型">
          <template slot-scope="scope">
            <span v-if="scope.row.invoiceType === '1'">蓝票</span>
            <span v-else>红票</span>
          </template>
        </el-table-column>
         <el-table-column prop="blueInvoiceLine" label="发票票种">
          <template slot-scope="scope">
            <span v-if="scope.row.blueInvoiceLine === 'pc'">电子数电普票</span>
            <span v-else>电子数电专票</span>
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="状态"></el-table-column>
        <el-table-column prop="des" label="详细信息"></el-table-column>
        <el-table-column prop="invoiceDownloadUrl" label="发票链接">
          <template slot-scope="scope">
            <a v-if="scope.row.invoiceDownloadUrl" :href="scope.row.invoiceDownloadUrl" target="_blank">发票</a>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">{{ scope.row.createTime | timeYMD }}</template>
        </el-table-column>
        <el-table-column width="150" prop="operation" label="操作">
          <template slot-scope="scope">
            <el-button class="orange" @click="deletetable(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:feeInvoiceDetailQuery
 *@Description:开票明细查询
 *@Copyright:格众科技
 */
export default {
  name: '/manage/main.feeInvoiceDetailQuery',
  data() {
    return {
      zero: 0, // 值为0的变量
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      searchInvoiceNo: '', // 搜索的发票编号
      searchInvoiceType: '', // 搜索的发票类型
    }
  },
  created() {
    this.getTablelist()
  },
  methods: {
    // 查询列表
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    // 获取列表数据
    getTablelist() {
       let loading = this.$loading()
       let params = {
         pageNo: this.pageNo,
         pageSize: this.pageSize,
         invoiceNo: this.searchInvoiceNo,
         invoiceType: this.searchInvoiceType
       }
      this.$get(`/invoiceDetailList`, params).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 删除
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        '确定要删除这条记录吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.$delete(`/invoiceDetail/${id}`).then(
            (res) => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: '删除成功',
                })
                this.commit()
              }
            },
            (error) => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
  },
}
</script>

<style lang="scss">
/* 可以在这里添加自定义样式 */
</style>